module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@3x-bc1ef62d18031c34f5523e14ddd03d51.png";